<template>
    <div v-if="field">
        <b-input-group>
            <template v-if="!customData.multiple">
                <div v-if="store.getters.isRunModePlatform">
                    <a :href="$mediaHttp.defaults.baseURL + this.content" target="_blank">
                        <span :class="`fiv-cla fiv-icon-${getFileExtension(content)}`" v-if="content != ''"> </span>
                        <br /> {{ fileName(content) }}
                    </a>
                </div>
                <div v-else>
                    <span :class="`fiv-cla fiv-icon-${getFileExtension(preview)}`" v-if="preview != ''"></span>
                     <br /> {{ fileName(preview) }}
                </div>
            </template>
            <template v-else>
                <div v-if="store.getters.isRunModePlatform">    
                    <a href="#" @click="seeFilesModal = true">{{ content.length }} files</a>
                    <main-dialog v-model="seeFilesModal" hide-header hide-footer size="sm">
                        <b-row>
                            <b-col sm="12" v-for="cont in content" :key="cont" class="file" >
                                <a :href="$mediaHttp.defaults.baseURL + cont" target="_blank">
                                    <span :class="`fiv-cla fiv-icon-${getFileExtension(cont)}`"> </span>
                                    {{ fileName(cont) }}
                                </a>
                            </b-col>
                        </b-row>
                    </main-dialog>
                </div>
                <div v-else>
                    <a href="#">{{ this.previews.length }} files</a>
                </div>
            </template>

            <b-form-invalid-feedback :id="field.key" style="display:block">
            {{ errors[0] || null }}
            </b-form-invalid-feedback>
         </b-input-group>

         <b-input-group v-if="!this.field.protected">
            <b-dropdown id="ddown1" text="Source" class="m-2">
                <b-dropdown-item @click="chooseFrom('library')" v-if="showChooseFromLibrary">Choose from library</b-dropdown-item>
                <b-dropdown-item @click="chooseFrom('device')" v-if="showChooseFromDevice">Choose from device</b-dropdown-item>
            </b-dropdown>
         </b-input-group>

      <main-dialog v-model="chooseModal.show" hide-footer hide-header size="lg">
          <Library @itemsSelected="itemSelected" v-if="this.chooseModal.type == 'library'"  :filterLibraries="customData.libraries" :filterExtensions="customData.extensions"/>
          <div v-if="this.chooseModal.type == 'device'">
            <b-form-file v-model="uploadFiles" @change="previewFiles" :multiple="customData.multiple"/>
            <b-button @click="upload" v-if="uploadFiles" class="m-2"> Upload </b-button>
          </div>
      </main-dialog>
    </div>
</template>

<style scoped>
.fiv-cla {
    font-size: 50px;
}

.file {
    cursor: pointer;
    padding: 10px;
    border-bottom: 1px solid #ccc;
}
</style>

<script>
import "file-icon-vectors/dist/file-icon-vectors.min.css"
import "file-icon-vectors/dist/file-icon-classic.min.css"

export default {
    name: "IdentityFieldFile",
    components: {
        Library: () => import('@/components/integrations/protokol/media/Index')
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Array
        },
        store: {
            type: Object
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            uploadModal: {
                show: false,
                file: null
            },
            chooseModal: {
                show: false,
                file: null,
                type: ''
            },
            image: null,
            imageLoadingError: false,
            uploadFiles: null,
            previews: [],
            seeFilesModal: false
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == "" || this.value === undefined || this.value === null) {
                    return this.constraints.default || ""
                }

                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        },

        customData() {
            let {chooseFromLibrary = false, chooseFromDevice = false, defaultLibrary = null, libraries = [], extensions = [], multiple = false} = this.constraints.custom_data.file || {}

            return {
                chooseFromLibrary: chooseFromLibrary,
                chooseFromDevice: chooseFromDevice,
                defaultLibrary: defaultLibrary,
                libraries: libraries,
                extensions: extensions,
                multiple: multiple
            }
        },

        localURL() {
            let url = this.$mediaHttp.defaults.baseURL || ''

            return url + this.content
        },

        preview() {
            return this.previews[0] || ''
        },

        showChooseFromLibrary() {
            return this.store.getters.isRunModePlatform && (this.customData.chooseFromLibrary && this.store.getters.isIntegrationActive('protokol-media'))
        },

        showChooseFromDevice() {
            return this.customData.chooseFromDevice && this.store.getters.isIntegrationActive('protokol-media')
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            this.errors = []

            if (val == "" && this.constraints.required) {
                 this.errors.push(this.translator("identityField.requiredField"))
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },

        fileName(name) {
            let cont = name.split("/")

            return cont[cont.length - 1]
        },

        itemSelected(d) {
            if (this.customData.multiple) {
                this.content = d.map(i => {
                    return "/media/library/" + i.library_uuid + "/get/" + i.key
                })
            } else {
                let item = null
                if (d.length > 0) {
                    item = d[0]
                }

                this.content = "/media/library/" + item.library_uuid + "/get/" + item.key
                this.selectedKey = item.key
            }

            
        },

        getFileExtension(name) {
            if (name === null) return null

            let l = name.split(".")

            return l[l.length - 1]
        },

        chooseFrom(source) {
            this.chooseModal.show = true
            this.chooseModal.type = source
        },

        upload() {
            let files = this.uploadFiles
            if (files.length === undefined) {
                files = [files]
            }

            this.store.dispatch("uploadMedia", {uploadDir: "", uuid: this.customData.defaultLibrary, files: files, field: this.field.key}).then(resp => {
                this.content = resp.data.map(d => {
                    return "/media/library/" + d.library_uuid + "/get/" + d.key
                })

                this.chooseModal.show = false
            }).catch(err => {
                console.log(err)
                this.$mainDialog.msgBoxOk(err.response.data.message)
            })
        },

        previewFiles(e) {
            this.previews = [];

            for (var i = 0; i < e.target.files.length; i++) {
                //this.previews.push(URL.createObjectURL(e.target.files[i]));
                this.previews.push(e.target.files[i].name)
            }
        }

    },

    mounted() {
        this.check(this.content)

        if(this.customData.multiple) {
            if (typeof this.content == 'string') {
                this.content = [this.content]
            }
        } else {
             if (typeof this.content == 'object') {
                this.content = this.content[0] || ''
            }
        }
    }

}
</script>